export enum AspectRatio {
  LANDSCAPE = '16 / 9',
  PORTRAIT = '19 / 24',
  WIDE = '2 / 1',
  SQUARE = '1 / 1',
}
